import { Divider, Skeleton, Space } from 'antd';
import SpinWithDescription from './SpinWithDescription';

export interface Props {
  tip?: string
  debug?: string
}

const PageLoadingIndicator = (props: Props) => {
  const { tip, debug } = props
  if (debug)
    console.debug('PageLoadingIndicator: ', debug);

  const getSkeleton = () => {
    return <div>
      <Space size='large'>
        <Skeleton.Avatar active size='large' />
        <Skeleton.Input active size='large' />
      </Space>
      <Divider />

      <Skeleton active paragraph={{ rows: 12 }} style={{ width: '77vw' }} />
    </div>
    // <Skeleton active paragraph={{ rows: 10 }} />;
  }

  return (process.env.REACT_APP_WHITELABEL_BUILD ?
    <div style={{
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      paddingTop: '50px',
      backgroundColor: 'white',
    }}>
      {getSkeleton()}
    </div>
    :
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    }}>
      <SpinWithDescription
        tip={tip}
      />
    </div>
  );
};

export default PageLoadingIndicator;
